<header>
  <div class="title">Error details</div>
  <button (click)="close()" class="closeBtn">
      <svg-icon class="close" src="/assets/icons/cross-thing.svg"></svg-icon>
  </button>
</header>

<div class="errorLog">
  <div class="errorLogTitle">Error log</div>
  <div class="errorLogList">
    <div *ngIf="showSpinner()" class="loader">
      <ui-loader class="spinner"></ui-loader>
      <div class="loaderText">Loading...</div>
    </div>
    <div class="serverError" *ngIf="showServerError()">{{ serverError }}</div>
    <div class="noErrors" *ngIf="showNoErrors()">No errors</div>
    <div class="errorLogListItem" *ngFor="let error of errors; index as i">
      <div class="errorTime">{{getDate(error.date)}}</div>
      <div class="errorMessage" [ngClass]="{'separator': i < errors.length - 1}">{{error.description}}</div>
    </div>
  </div>
</div>

<div class="copyLogWrap">
  <div class="copyLog" (click)="copyLog()" [ngClass]="{'disabledCopyLogBtn': !errors || !errors.length}">
    <svg-icon class="copyLogIcon" src="/assets/icons/copy.svg"></svg-icon>
    <ui-button name="COPY LOG" [type]='buttonTypes.Simple' [isDisabled]="!errors || !errors.length"></ui-button>
    <div *ngIf="tooltipText" class="tooltip">{{tooltipText}}</div>
  </div>
</div>
